import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "篩檢年份",
    isNumber: true,
    isSum: true,
  },
];

export const IADLTotalScoreToCheckYear = {
  label: "IADL需協助項次數 vs 篩檢年份",
  key: "IADLTotalScoreToCheckYear",
  path: "ElderlyHealth/IADLTotalScoreToCheckYear",
  api: "TCS_V_OHCheckItems01V",
  render: (options) => (
    <Diagram.ElderlyHealth.IADLTotalScoreToCheckYear {...options} />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "IADL_count",
      field: "IADL_count",
      header: "需協助項次數",
      isNumber: true,
      isSkip: true,
    },
  ],
  levelColumns,
  columns: [],
  formatRows: ({ data }) => {
    return {
      ...data,
      IADL_count:
        ([8304, 8305].includes(data.IADL1) ? 1 : 0) +
        ([8309, 8310].includes(data.IADL2) ? 1 : 0) +
        ([8314].includes(data.IADL3) ? 1 : 0) +
        ([8318, 8319].includes(data.IADL4) ? 1 : 0) +
        ([8322].includes(data.IADL5) ? 1 : 0),
    };
  },
};
